<script setup>
import { computed, watch, onMounted, onBeforeUnmount } from "vue";
import SideMenu from "@/components/global/SideMenu";
import BeneficiaryDrawer from "@/components/global/drawer/Drawer";
import { useRoute, useRouter } from "vue-router";
import { useGlobalStore, useListStore } from "@/stores";

const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const snackbar = computed(() => {
  return globalStore.snackbar;
});

const listStore = useListStore();

let intervalId;

onMounted(() => {
  intervalId = setInterval(async () => {
    try {
      await listStore.fetchListHashes();
    } catch (error) {
      console.error("Error fetching list hashes:", error);
    }
  }, 120000); // every 2 minutes
});

onBeforeUnmount(() => {
  clearInterval(intervalId);
});

watch(
  () => route.query.error,
  (errorQuery) => {
    if (errorQuery === "true") {
      globalStore.showSnackbar({
        show: true,
        text: "An error occurred!",
        timeout: 3000,
        type: "error",
        position: "top right",
      });
      router.replace({ query: { ...route.query, error: undefined } });
    }
  },
  { immediate: true }
);
</script>

<template>
  <v-app>
    <v-main>
      <v-snackbar
        v-model="snackbar.show"
        :timeout="snackbar.timeout"
        :color="snackbar.type ? snackbar.type : 'error'"
        :location="snackbar.position ? snackbar.position : 'top right'"
      >
        {{ snackbar.text }}

        <template #actions>
          <v-btn color="white" variant="text" @click="snackbar.show = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <SideMenu v-if="route.path != '/' && route.path != '/reset-password'" />
      <router-view />
      <BeneficiaryDrawer />
    </v-main>
  </v-app>
</template>

<style lang="scss">
.v-container {
  padding: 30px 50px;
}
</style>
